import { render, staticRenderFns } from "./orderbuy.vue?vue&type=template&id=29345511&scoped=true"
import script from "./orderbuy.vue?vue&type=script&lang=js"
export * from "./orderbuy.vue?vue&type=script&lang=js"
import style0 from "./orderbuy.vue?vue&type=style&index=0&id=29345511&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29345511",
  null
  
)

export default component.exports